import { Section } from '../components/Section';
import { Container } from '../components/Container';
import { Button } from '../components/Button';

const APP_STORE_URL = 'https://www.nuvemshop.com.br/loja-de-aplicativos/';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer>
      {/* CTA Band */}
      <Section background="brand-dark">
        <Container maxWidth="text">
          <div style={{ textAlign: 'center' }}>
            <h2
              style={{
                fontSize: '24px',
                fontWeight: 800,
                fontFamily: 'var(--font-heading)',
                color: '#ffffff',
                lineHeight: 1.2,
              }}
            >
              Pronto para começar?
            </h2>
            <p
              style={{
                fontSize: '16px',
                fontWeight: 400,
                color: 'rgba(255,255,255,0.80)',
                marginTop: 'var(--spacing-md)',
                lineHeight: 1.5,
              }}
            >
              Instale o Assine e crie seu primeiro plano de assinatura em
              minutos.
            </p>
            <div style={{ marginTop: 'var(--spacing-lg)' }}>
              <Button variant="gradient" href={APP_STORE_URL}>
                Instalar no Nuvemshop
              </Button>
            </div>
          </div>
        </Container>
      </Section>

      {/* Footer Band -- slightly darker for separation */}
      <div
        style={{
          backgroundColor: '#141425',
          padding: 'var(--spacing-lg) var(--spacing-md)',
        }}
      >
        <Container maxWidth="content">
          <div className="footer-inner">
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-sm)' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 190 44"
                width={100}
                height={24}
                aria-label="Assine"
              >
                <g transform="translate(4, 2)">
                  <rect x="0" y="18" width="7.5" height="18" rx="3.75" fill="#A855F7"/>
                  <rect x="10" y="10" width="7.5" height="26" rx="3.75" fill="#E84393"/>
                  <rect x="20" y="2" width="7.5" height="34" rx="3.75" fill="#FF6B6B"/>
                  <path d="M31 12 L33.5 7 L36 12" stroke="#FF8E53" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="33.5" y1="7" x2="33.5" y2="17" stroke="#FF8E53" strokeWidth="2" strokeLinecap="round"/>
                </g>
                <text
                  x="52"
                  y="31"
                  fontFamily="Nunito, -apple-system, BlinkMacSystemFont, sans-serif"
                  fontWeight="800"
                  fontSize="28"
                  letterSpacing="-0.02em"
                  fill="#F0F0F5"
                >assine</text>
              </svg>
            </div>
            <div
              style={{
                fontSize: '13px',
                color: '#6b7280',
                display: 'flex',
                gap: 'var(--spacing-md)',
                alignItems: 'center',
              }}
            >
              <span>&copy; {year} Assine</span>
              <a
                href="/privacy"
                style={{
                  color: '#6b7280',
                  textDecoration: 'none',
                  transition: 'color 150ms ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#d1d5db';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#6b7280';
                }}
              >
                Política de Privacidade
              </a>
            </div>
          </div>
        </Container>
        <style>{`
          .footer-inner {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          @media (max-width: 639px) {
            .footer-inner {
              flex-direction: column;
              gap: var(--spacing-md);
              text-align: center;
            }
          }
        `}</style>
      </div>
    </footer>
  );
}
